import { render, staticRenderFns } from "./AddedDictionaryEntries.vue?vue&type=template&id=1bcb01ee&scoped=true"
import script from "./AddedDictionaryEntries.vue?vue&type=script&lang=js"
export * from "./AddedDictionaryEntries.vue?vue&type=script&lang=js"
import style0 from "./AddedDictionaryEntries.vue?vue&type=style&index=0&id=1bcb01ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcb01ee",
  null
  
)

export default component.exports